import axios from '../config/api'

const state = () => ({
  data: null,
  uuid: null,
  payload: null,
  isError: false,
  errorMessage: null,
  isSuccess: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async otpRequest({ commit }, payload) {
    commit('otpRequest')
    await axios
      .post('/otp', payload)
      .then(response => {
        commit('otpRequestSuccess', response.data)
      })
      .catch(() => {
        commit('otpRequestFailure')
      })
  },

  async verifyOtp({ commit }, payload) {
    commit('verifyOtpRequest')
    await axios
      .post('/otp/verify/user', payload)
      .then(response => {
        commit('verifyOtpRequestSuccess', response.data?.data?.token)
        localStorage.setItem('tokenOTP', response.data?.data?.token)
      })
      .catch(error => {
        commit(
          'verifyOtpRequestFailure',
          error.response?.data?.message,
        )
        localStorage.removeItem('tokenOTP')
      })
  },
}

// mutations
const mutations = {
  otpRequest() {
    state.isLoading = true
    state.isSuccess = false
    state.isError = false
  },
  otpRequestSuccess(state, payload) {
    state.uuid = payload.data.uuid
    state.isLoading = false
    state.isSuccess = true
    state.isError = false
  },
  otpRequestFailure() {
    state.isLoading = false
    state.isSuccess = false
    state.isError = true
  },
  verifyOtpRequest() {
    state.isLoading = true
    state.isSuccess = false
    state.isError = false
    state.errorMessage = null
  },
  verifyOtpRequestSuccess(state, payload) {
    state.data = payload
    state.isLoading = false
    state.isSuccess = true
    state.isError = false
    state.errorMessage = null
  },
  verifyOtpRequestFailure(state, payload) {
    state.isLoading = false
    state.isSuccess = false
    state.isError = true
    state.errorMessage = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
